// extracted by mini-css-extract-plugin
export default {"container":"Selector_container__TMdXV","selector":"Selector_selector__2zxlf","arrow":"Selector_arrow__Z3Z94","arrow_icon":"Selector_arrow_icon__-l-Up"};